import React from 'react';
import moment from 'moment';
import TruncatedText from '../../../../components/common/TruncatedText';
import {useDispatch} from 'react-redux';
import {setSuppressDateIndicator} from '../../../../redux/slices/timeline';

interface EndDateFlagProps {
  position: { left?: string; right?: string; top: string };
  originalDate?: string;
}

export const EndDateFlag: React.FC<EndDateFlagProps> = ({
  position,
  originalDate
}) => {
  const dispatch = useDispatch();
  const original = originalDate ? moment(originalDate).format('ddd, MMM DD, YYYY') : undefined;

  return (
    <div
      className="absolute !cursor-default"
      style={{
        width: 1,
        left: position.left,
        height: "100%",
        backgroundColor: '#8b5cf6',
      }}
      onMouseEnter={() => dispatch(setSuppressDateIndicator(true))}
      onMouseLeave={() => dispatch(setSuppressDateIndicator(false))}
    >
      <div
        className="sticky"
        style={{
          top: position?.top,
        }}
      >
        <TruncatedText
          text="End"
          tooltipTitle={`End • EOD (${original})`}
          className="absolute text-xs bg-violet-50 dark:bg-[#1b2333] text-black/80 dark:text-white/80 border border-violet-500 dark:border-violet-400 whitespace-nowrap overflow-hidden text-ellipsis px-2 py-0.5 rounded-l"
          style={{ transform: 'translateX(-100%)', left: 1 }}
          placement="bottom-start"
          as="span"
        />
      </div>
    </div>
  );
};